module.exports = __webpack_public_path__ + "img/56.3.TP.4cd4223c.png";